<template>
    <div class="root flex wrap center vcenter">
        <div class="item flex wrap center vcenter">
            <MetaBox :meta="{
                key: 'remind_at',
                type: 'datetime',
                name: 'تاریخ و ساعت یادآوری'
            }" :vm="models['remind_at'] || ''" @onchange="onchange"></MetaBox>
        </div>
        <div v-if="Number(data?.user?.grade) <= 2" class="item flex wrap center vcenter">
            <MetaBox :meta="{
                key: 'uid',
                type: 'dropdown',
                name: 'کارشناس گیرنده',
                extras: 'R0:key=data,value=experts'
            }" :vm="models['uid'] || ''" @onchange="onchange"></MetaBox>
        </div>
        <div class="item flex wrap center vcenter">
            <MetaBox :meta="{
                key: 'message',
                type: 'textarea',
                name: 'متن پیام',
                extras: 'R0:key=minimal,value=YES'
            }" :vm="models['message'] || ''" @onchange="onchange"></MetaBox>
        </div>
        <div class="item flex wrap center vcenter">
            <Button :meta="{
                key: 'submit',
                name: 'ثبت یادآور'
            }" :active="loading" :disabled="disabled" @onclick="submit"></Button>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { defineAsyncComponent } from 'vue'

import Button from '../Form/Button.vue'

export default {
    name: 'Reminder',
    props: ['data'],
    inject: ['base'],
    components: {
        MetaBox: defineAsyncComponent(() => import('../Form/Inputs/MetaBox.vue')),
        Button
    },
    data() {
        return {
            models: {},
            errors: {},
            loading: false
        }
    },
    methods: {
        onchange(obj) {
            this.models[obj.key] = obj.value
            this.errors[obj.key] = obj.error
        },
        submit() {
            if (this.errors['remind_at'] || !this.base.Util().validate(this.models['remind_at'])) {
                this.base.Notification().error({
                    code: 1000,
                    text: 'تاریخ یادآوری'
                })
                return
            }

            if (!this.base.Util().validate(this.models['message'])) {
                this.base.Notification().error({
                    code: 1000,
                    text: 'متن پیام'
                })
                return
            }

            this.loading = true

            this.base.API().post(`Service/Global/Register`, {
                entity_type: 'REMINDER',
                data: [
                    {
                        uid: this.models['uid'] || '{My:0}',
                        message: this.models['message'],
                        remind_at: Number(this.models['remind_at']),
                        done: false
                    }
                ]
            }, (response) => {
                this.loading = false
                if (this.base.Util().success(response)) {
                    this.models = {}
                    this.base.Notification().toast('نتیجه عملیات', 'ثبت با موفقیت انجام شد!', 'success')
                    this.$emit('onresult')
                } else
                    this.base.Notification().error({
                        code: response.data.errorCode,
                        referr: obj.entity_type,
                        text: response.data.message
                    })
            }, (error) => {
                this.loading = false
                this.base.Notification().error({
                    code: 5000,
                    text: 'خطایی رخ داد، لطفا مجددا تلاش کنید!'
                })
            })
        }
    }
}
</script>

<style scoped src="../../assets/css/components/dialogs/reminder.css"></style>